<div class="box" [class.box--massive-upload]="isMassiveUpload">
  <ng-container *ngIf="!isMassiveUpload; else massiveUploadTemplate">

    <div class="header">
      <div class="content greendAnalityco">
        {{ data?.title || 'N/A' }}
      </div>
    </div>

    <div class="content-card list-card">

      <div class="fields-group">

        <app-select-search
          *ngIf="data"
          class="selected"
          [_dataSource]="data?.data"
          [textInput]="data?.optionsCardSelect?.textInput"
          [dataShow]="data?.optionsCardSelect?.dataShow"
          [otherFilter]="data?.optionsCardSelect?.otherFilter"
          [dataValue]="data?.optionsCardSelect?.dataValue"
          [isCard]="data?.optionsCardSelect?.isCard"
          [isCardImage]="data?.optionsCardSelect?.isCardImage"
          [isDescription]="data?.optionsCardSelect?.isDescription"
          [card]="{
            img: data?.optionsCardSelect?.card?.img,
            title: data?.optionsCardSelect?.card?.title,
            subTitle: data?.optionsCardSelect?.card?.subTitle,
            finalLeft: data?.optionsCardSelect?.card?.finalLeft,
            finalRight: data?.optionsCardSelect?.card?.finalRight,
            itemKey: data?.optionsCardSelect?.card?.itemKey,
            itemValue: data?.optionsCardSelect?.card?.itemValue
          }"
          (onSelectionChange)="selected($event)"
          [siteCtrl]="controlSelected"
          [inputType]="'text'"
          [selectOpen]="true"
          [placeholder]="'Seleccione...'">
        </app-select-search>

      </div>

      <div
        style="width: 100%; margin-top: 10px;"
        *ngIf="data?.message !== undefined"
        [ngClass]="data?.colorMessage !== undefined ? data?.colorMessage : ''">
        {{ data?.message || '' }}
      </div>

      <br>

      <div class="actions-dialog" style="margin: 3px;">

        <button
          mat-button
          class="btn-cancelar"
          *ngIf="data?.btnClose === true"
          (click)="close()">
          {{ data?.textClose }}
        </button>

        &nbsp;&nbsp;

        <button
          mat-button
          class="btn-generar"
          *ngIf="data?.btnConfirm === true"
          (click)="save()">
          {{ data?.textConfirm }}
        </button>

      </div>

    </div>

  </ng-container>

  <!-- VISTA NUEVA PARA CARGUE MASIVO-->
  <ng-template #massiveUploadTemplate>

    <section class="massive-upload-dialog">

      <header class="massive-upload-dialog__header">
        <mat-icon class="massive-upload-dialog__header-icon">
          {{ reportsView === 'uploads' && activeTab === 'reports' ? 'bar_chart' : 'post_add' }}
        </mat-icon>
        <span class="massive-upload-dialog__title">
          <ng-container *ngIf="reportsView === 'uploads' && activeTab === 'reports'; else mainTitle">
            Actualizaciones de {{ getOptionTitle(reportsOperation) | lowercase }}
          </ng-container>
          <ng-template #mainTitle>{{ data?.title || 'Gestión masiva' }}</ng-template>
        </span>
        <button type="button" class="massive-upload-dialog__close" aria-label="Cerrar" (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
      </header>

      <nav class="massive-tabs" *ngIf="!(activeTab === 'reports' && reportsView === 'uploads')">
        <button type="button" class="massive-tabs__tab"
                [class.massive-tabs__tab--active]="activeTab === 'upload'"
                (click)="setTab('upload')">
          <mat-icon>cloud_upload</mat-icon>Cargue masivo
        </button>
        <button type="button" class="massive-tabs__tab"
                [class.massive-tabs__tab--active]="activeTab === 'reports'"
                (click)="setTab('reports')">
          <mat-icon>bar_chart</mat-icon>Actualizaciones e informes
        </button>
      </nav>

      <main class="massive-upload-dialog__body">

        <!-- PASO 2: cargues realizados de la operación -->
        <ng-container *ngIf="activeTab === 'reports' && reportsView === 'uploads'; else operationsView">

          <p class="massive-upload-dialog__description">Selecciona el cargue que deseas revisar</p>

          <div class="massive-upload-dialog__loading" *ngIf="reportsLoading">
            <mat-spinner diameter="30"></mat-spinner>
            <span>Cargando actualizaciones...</span>
          </div>

          <div class="massive-upload-dialog__empty" *ngIf="!reportsLoading && reportsUploads.length === 0">
            No hay actualizaciones realizadas.
          </div>

          <div class="massive-upload-options" *ngIf="!reportsLoading && reportsUploads.length > 0">
            <div class="massive-upload-item" *ngFor="let upload of reportsUploads">
              <div class="massive-upload-item__icon" aria-hidden="true">
                <mat-icon>description</mat-icon>
              </div>

              <div class="massive-upload-item__info">
                <strong>{{ getUploadDate(upload) }}</strong>
                <span class="massive-upload-item__file"
                      [matTooltip]="getUploadFileName(upload)">{{ getUploadFileName(upload) || 'Documento no reportado' }}</span>
                <span class="massive-upload-item__status"
                      [ngClass]="'massive-upload-item__status--' + getUploadStatusClass(upload)">
                  <mat-icon>{{ getUploadStatusIcon(upload) }}</mat-icon>
                  {{ (upload?.Status || 'No reportado') | titlecase }}
                </span>
              </div>

              <button mat-flat-button type="button" class="btn-ver-informe" (click)="viewReport(upload)">
                Ver informe
              </button>
            </div>
          </div>

        </ng-container>

        <!-- PASO 1: operaciones -->
        <ng-template #operationsView>

          <p class="massive-upload-dialog__description">
            <ng-container *ngIf="activeTab === 'upload'">
              {{ data?.optionsCardSelect?.textInput || 'Selecciona el tipo de actualización a realizar' }}
            </ng-container>
            <ng-container *ngIf="activeTab === 'reports'">Selecciona la operación que deseas consultar</ng-container>
          </p>

          <div
            class="massive-upload-options"
            *ngIf="data?.data?.length; else emptyOptions">

            <div
              class="massive-option-card"
              [class.massive-option-card--inline]="activeTab === 'reports'"
              *ngFor="let item of data?.data; trackBy: trackByOption">

              <div class="massive-option-card__header">
                <div
                  class="massive-option-card__icon"
                  aria-hidden="true">
                  <ng-container *ngIf="hasOptionImage(item); else defaultIcon">
                    <img class="massive-option-card__img-icon" [src]="getOptionImageSrc(item)" alt="">
                  </ng-container>
                  <ng-template #defaultIcon>
                    <mat-icon>{{ getOptionIcon(item) }}</mat-icon>
                  </ng-template>
                </div>

                <div class="massive-option-card__info">
                  <h3>{{ getOptionTitle(item) }}</h3>
                  <p *ngIf="getOptionSubtitle(item)">{{ getOptionSubtitle(item) }}</p>
                </div>
              </div>

              <div class="massive-option-card__actions-row">
                <button mat-flat-button class="btn-iniciar" *ngIf="activeTab === 'upload'" (click)="chooseOption(item)">
                  Iniciar
                </button>
                <button mat-stroked-button class="btn-informes" *ngIf="activeTab === 'reports'"
                        [disabled]="isReportDisabled(item)"
                        [class.btn-informes--active]="!isReportDisabled(item)"
                        (click)="viewUpdates(item)">
                  Ver actualizaciones
                </button>
              </div>

            </div>

          </div>

          <ng-template #emptyOptions>
            <div class="massive-upload-dialog__empty">
              No hay opciones disponibles.
            </div>
          </ng-template>

          <div class="massive-upload-dialog__note" *ngIf="activeTab === 'reports'">
            <mat-icon>info_outline</mat-icon>
            Cargue masivo tiene su propio flujo para iniciar y cargar archivos.
          </div>

          <div
            class="massive-upload-dialog__message"
            *ngIf="data?.message !== undefined"
            [ngClass]="data?.colorMessage !== undefined ? data?.colorMessage : ''">
            {{ data?.message || '' }}
          </div>

        </ng-template>

      </main>

      <footer class="massive-upload-dialog__actions">

        <button
          *ngIf="activeTab === 'reports' && reportsView === 'uploads'; else closeButton"
          mat-stroked-button
          type="button"
          class="massive-upload-dialog__btn massive-upload-dialog__btn--cancel"
          (click)="backToOperations()">
          Volver
        </button>
        <ng-template #closeButton>
          <button
            mat-stroked-button
            type="button"
            class="massive-upload-dialog__btn massive-upload-dialog__btn--cancel"
            (click)="close()">
            {{ activeTab === 'reports' ? 'Cerrar' : (data?.textClose || 'Cancelar') }}
          </button>
        </ng-template>

      </footer>

    </section>

  </ng-template>

</div>
